export const Breakpoints = {
    smallScreenLimit: 767,
    //Please make sure to match the number below with the settings.scss screensizes
    mobileScreen: 478,
}
